import tippy from "tippy.js";
import Components from "../components";
import ClipboardJS from "clipboard";

class Clipboard extends Components.Base {
  initialize() {
    this.clipboard = new ClipboardJS(this.el);
    this.clipboard.on("success", this.onSuccess);
    this.clipboard.on("error", this.onError);
  }

  deinitialize() {
    this.clipboard.destroy();
  }

  onError(e) {
    tippy(e.trigger, {
      content: "Press Cmd-C to Copy",
      showOnCreate: true,
      onHidden(instance) {
        instance.destroy();
      },
    });
  }

  onSuccess(e) {
    tippy(e.trigger, {
      content: "Copied!",
      showOnCreate: true,
      onHidden(instance) {
        instance.destroy();
      },
    });
  }
}

Components.collection.register({ selector: ".c-clipboard", klass: Clipboard });
